/******/ (() => {
  // webpackBootstrap
  class sizeGuideModal extends HTMLElement {
    constructor() {
      super();
      this.nav = this.querySelectorAll(".navbar_tab");
      this.tabs = this.querySelectorAll(".tab_content");
      this.modalOpen = this.querySelector(".js-sizeguide-open");
      this.modalClose = this.querySelectorAll(".js-sizeguide-close");
      this.modal = this.querySelector(".lightbox");
      this.bg = document.querySelector(".lightbox__overlay");
      this.parentShopifySection = this.closest(".shopify-section");
      this.nav.forEach((el) => {
        el.addEventListener("click", (event) => this.toggleTabs(el, event));
      });
      this.modalOpen.addEventListener("click", () => this.toogleModal());
      this.modalClose.forEach((el) => {
        el.addEventListener("click", () => this.toogleModal());
      });
    }

    toogleModal() {
      document.querySelector("body").classList.toggle("lightbox-open");
      this.modal.classList.toggle("actif");
      this.bg.classList.toggle("active");
      this.parentShopifySection.classList.toggle("active");
    }
    toggleTabs(el, event) {
      event.preventDefault();
      const target = el.getAttribute("data-tab");
      this.nav.forEach((el) => {
        el.classList.remove("active");
      });
      el.classList.add("active");
      this.tabs.forEach((tab) => {
        if (tab.getAttribute("data-tab") === target) {
          if (tab.classList.contains("actif")) return;
          tab.classList.add("actif");
        } else {
          tab.classList.remove("actif");
        }
      });
    }
  }

  customElements.define("size-guide-modal", sizeGuideModal);

  /******/
})();
